"use client";

import { useContentfulInspectorMode } from "@scott/contentful/live-preview-init";
import { AccordionPreview } from "@/scott/ui/elements/accordion/accordion.preview";
import type { AccordionBlockProps } from "./accordion-block";
import { ContentBlocks } from "./content-blocks";

export function AccordionBlockPreview(props: Readonly<AccordionBlockProps>) {
  const inspector = useContentfulInspectorMode();

  const items = props.items.map((item, index) => ({
    id: item.id ?? `${props.id}-item-${index}`,
    label: item.label,
    children: (
      <ContentBlocks
        blocks={item.children}
        disablePreviewInspector
        pageContext={props.pageContext}
      />
    ),
    inspectorProps:
      inspector({ fieldId: "internalName", entryId: item.sys?.id }) ??
      undefined,
  }));

  return <AccordionPreview {...props} items={items} mode="D2C" />;
}
